import { Footer } from '../components/Footer';

export function Tos() {
  return (
    <div className="rl-page" style={{ maxWidth: 760 }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, margin: '0 0 8px' }}>Terms of Service</h1>
      <p style={{ color: 'var(--text-dim)', fontSize: 12, marginBottom: 24 }}>
        Last updated: 2026-06-19
      </p>

      <Article title="1. What Riffloop is">
        Riffloop is a personal-practice tool that uses audio source separation to isolate stems
        (vocals, drums, bass, piano, guitar, other) from songs you provide. It is available as a
        Chrome extension that operates on YouTube videos and as a web app that accepts YouTube
        URLs or audio file uploads.
      </Article>

      <Article title="2. Account and acceptable use">
        You sign in with Google. You're responsible for keeping your account secure. You agree to
        use Riffloop only for lawful purposes and only on content you have the right to process.
      </Article>

      <Article title="3. Copyright and your responsibility">
        <strong>You are solely responsible</strong> for ensuring you have the legal right to
        process any audio you provide to Riffloop, whether by URL or by file upload. By using the
        service you confirm that:
        <ul>
          <li>You own the rights to the audio, OR</li>
          <li>You hold a license that permits this kind of personal processing, OR</li>
          <li>Your use qualifies as fair use, fair dealing, or an equivalent exception under
            applicable law.</li>
        </ul>
        Riffloop is intended for personal, non-commercial practice and learning. You agree not to
        redistribute separated stems or use them to compete with the original rights-holders'
        business.
      </Article>

      <Article title="4. DMCA / takedown policy">
        If you believe content processed via Riffloop infringes your copyright, please send a
        DMCA-compliant notice to <a href="mailto:riffloopapp@gmail.com">riffloopapp@gmail.com</a>{' '}
        including:
        <ol>
          <li>Identification of the copyrighted work claimed to be infringed.</li>
          <li>Identification of the material claimed to be infringing and information reasonably
            sufficient to permit us to locate it.</li>
          <li>Your contact information (address, phone, email).</li>
          <li>A statement that you have a good-faith belief that use of the material is not
            authorized.</li>
          <li>A statement, under penalty of perjury, that the information is accurate and that you
            are the rights-holder or authorized to act on their behalf.</li>
          <li>Your physical or electronic signature.</li>
        </ol>
        Designated DMCA agent: riffloop, riffloopapp@gmail.com. We will respond to valid notices
        promptly, remove the material, and may suspend repeat-infringer accounts.
      </Article>

      <Article title="5. Subscription billing">
        Pro is a recurring subscription billed via PayPro Global. You can cancel anytime from the Billing
        page; access continues until the end of the current billing period. We don't issue
        pro-rated refunds for partial months, but contact us at riffloopapp@gmail.com if you have a
        special case.
      </Article>

      <Article title="6. Data we store">
        See our <a href="/privacy">Privacy Policy</a>. In short: account email and profile from
        Google, your saved sections, your separation history, and billing records. We do not sell
        your data.
      </Article>

      <Article title="7. Limitations">
        Stem separation quality varies by source. We make no guarantees about audio quality,
        availability, or fitness for any particular purpose. The service is provided "as is."
      </Article>

      <Article title="8. Termination">
        You can delete your account at any time from Settings. We can suspend accounts that abuse
        the service or violate these Terms.
      </Article>

      <Article title="9. Changes">
        We may update these Terms. We'll post the new version with a new "Last updated" date and
        notify active users by email for material changes.
      </Article>

      <Article title="10. Contact">
        Questions? <a href="mailto:riffloopapp@gmail.com">riffloopapp@gmail.com</a>
      </Article>

      <Footer />
    </div>
  );
}

function Article({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 16, fontWeight: 600, margin: '0 0 10px' }}>{title}</h2>
      <div style={{ color: 'var(--text-dim)', fontSize: 14, lineHeight: 1.65 }}>{children}</div>
    </section>
  );
}
